import { useCallback } from 'react';

import { markVisitorLimitDismissed } from 'helpers/visitor-limit-exceeded';

interface UseVisitorLimitExceededStorageReturn {
  markDismissed: (count: number) => void;
}

export function useVisitorLimitExceededStorage(): UseVisitorLimitExceededStorageReturn {
  const markDismissed = useCallback((count: number): void => {
    markVisitorLimitDismissed(count);
  }, []);

  return {
    markDismissed,
  };
}
